import { nanoid } from 'nanoid';

export const createUUID = () => {
  return nanoid();
};
